var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "animated fadeIn"
  }, [_c('form', {
    attrs: {
      "id": "svcform"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "d-flex"
  }, [_c('div', {
    staticClass: "col-lg-9"
  }, _vm._l((_vm.depositSlips), function(deposit, index) {
    return _c('div', {
      key: index,
      staticClass: "card mb-3"
    }, [_c('div', {
      staticClass: "card-header d-flex align-items-center justify-content-between",
      on: {
        "click": function($event) {
          _vm.toggleCollapse(index)
        }
      }
    }, [_c('span', [_c('i', {
      staticClass: "fa fa-angle-down mr-2"
    }), _vm._v(" \n                    COD Closure Deposit " + _vm._s(index + 1) + "\n                  ")]), _vm._v(" "), (index != 0) ? _c('button', {
      staticClass: "mt-1 btn btn-sm btn-danger d-flex justify-content-center align-items-center",
      staticStyle: {
        "width": "25px",
        "height": "25px",
        "border-radius": "50%",
        "padding": "0"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.removeDepositSlip(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "collapse",
      class: {
        show: _vm.isCollapsed === index
      }
    }, [_c('div', {
      staticClass: "card-body d-flex"
    }, [_c('div', {
      staticClass: "col-sm-7"
    }, [_c('div', {
      staticClass: "card"
    }, [_c('div', {
      staticClass: "card-header"
    }, [_vm._v("COD Yesterday's Closure Of SVC")]), _vm._v(" "), _c('div', {
      staticClass: "card-body"
    }, [(_vm.localhubIsRSC) ? _c('div', {
      staticClass: "form-group"
    }, [_c('div', {
      staticClass: "input-group"
    }, [_c('div', {
      staticClass: "input-group-prepend",
      staticStyle: {
        "width": "140px"
      }
    }, [_c('span', {
      staticClass: "input-group-text",
      staticStyle: {
        "width": "140px"
      }
    }, [_vm._v("RSC Owner "), _c('font', {
      attrs: {
        "color": "red"
      }
    }, [_vm._v(" *")])], 1)]), _vm._v(" "), _c('vue-element-loading', {
      attrs: {
        "spinner": "mini-spinner",
        "color": "#FF6700",
        "active": _vm.rscLoading
      },
      on: {
        "update:active": function($event) {
          _vm.rscLoading = $event
        }
      }
    }), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (deposit['RSCOwner']),
        expression: "deposit['RSCOwner']"
      }, {
        name: "validate",
        rawName: "v-validate",
        value: ({
          required: true
        }),
        expression: "{required: true}"
      }],
      staticClass: "form-control",
      class: {
        'form-control': true,
        'error': _vm.errors.has('RSCOwner' + index)
      },
      staticStyle: {
        "margin-right": "-8px"
      },
      attrs: {
        "name": 'RSCOwner' + index,
        "disabled": index > 0 ? true : false
      },
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(deposit, 'RSCOwner', $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, function($event) {
          _vm.setRSCOwner(index)
        }]
      }
    }, [_c('option', {
      attrs: {
        "value": ""
      }
    }, [_vm._v("--Select--")]), _vm._v(" "), _vm._l((_vm.RSCOwnerList), function(rscowner_obj) {
      return _c('option', {
        domProps: {
          "value": rscowner_obj
        }
      }, [_vm._v(_vm._s(rscowner_obj.OutSourcingName) + " - " + _vm._s(rscowner_obj.EffectiveFromDate) + " To " + _vm._s(rscowner_obj.EffectiveToDate))])
    })], 2), _vm._v(" "), _vm._m(0, true)], 1), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.errors.has('RSCOwner' + index)),
        expression: "errors.has('RSCOwner'  + index)"
      }],
      staticClass: "text-danger"
    }, [_vm._v("RSC owner is required.")])]) : _vm._e(), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.isFnF),
        expression: "!isFnF"
      }],
      staticClass: "form-group"
    }, [_c('div', {
      staticClass: "input-group"
    }, [_c('div', {
      staticClass: "input-group-prepend",
      staticStyle: {
        "width": "140px"
      }
    }, [_c('span', {
      staticClass: "input-group-text",
      staticStyle: {
        "width": "140px"
      }
    }, [_vm._v("Delivery Date "), _c('font', {
      attrs: {
        "color": "red"
      }
    }, [_vm._v(" *")])], 1)]), _vm._v(" "), _c('b-form-input', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ({
          required: true
        }),
        expression: "{required: true}"
      }],
      class: {
        'form-control': true,
        'error': _vm.errors.has('DeliveryDate' + index)
      },
      staticStyle: {
        "margin-right": "-5px"
      },
      attrs: {
        "disabled": "",
        "type": "date",
        "name": 'DeliveryDate' + index
      },
      model: {
        value: (deposit['DeliveryDate']),
        callback: function($$v) {
          _vm.$set(deposit, 'DeliveryDate', $$v)
        },
        expression: "deposit['DeliveryDate']"
      }
    }), _vm._v(" "), _vm._m(1, true)], 1), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.errors.has('DeliveryDate' + index)),
        expression: "errors.has('DeliveryDate'  + index)"
      }],
      staticClass: "text-danger"
    }, [_vm._v("Delivery date is required. ")])]), _vm._v(" "), _c('div', {
      staticClass: "form-group"
    }, [_c('div', {
      staticClass: "input-group"
    }, [_c('div', {
      staticClass: "input-group-prepend",
      staticStyle: {
        "width": "140px"
      }
    }, [_c('span', {
      staticClass: "input-group-text",
      staticStyle: {
        "width": "140px"
      }
    }, [_vm._v("Deposit Date"), _c('font', {
      attrs: {
        "color": "red"
      }
    }, [_vm._v(" *")])], 1)]), _vm._v(" "), _c('b-form-input', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ({
          required: true
        }),
        expression: "{required: true}"
      }],
      class: {
        'form-control': true,
        'error': _vm.errors.has('DepositDate' + index)
      },
      staticStyle: {
        "margin-right": "-5px"
      },
      attrs: {
        "type": "date",
        "name": 'DepositDate' + index,
        "min": _vm.minDate,
        "max": _vm.maxDate
      },
      model: {
        value: (deposit['DepositDate']),
        callback: function($$v) {
          _vm.$set(deposit, 'DepositDate', $$v)
        },
        expression: "deposit['DepositDate']"
      }
    }), _vm._v(" "), _vm._m(2, true)], 1), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.errors.has('DepositDate' + index)),
        expression: "errors.has('DepositDate'  + index)"
      }],
      staticClass: "text-danger"
    }, [_vm._v("Deposit date is required")])]), _vm._v(" "), _c('div', {
      staticClass: "form-group"
    }, [_c('div', {
      staticClass: "input-group"
    }, [_c('div', {
      staticClass: "input-group-prepend",
      staticStyle: {
        "width": "140px"
      }
    }, [_c('span', {
      staticClass: "input-group-text",
      staticStyle: {
        "width": "140px"
      }
    }, [_vm._v("Deposit Amount "), _c('font', {
      attrs: {
        "color": "red"
      }
    }, [_vm._v(" *")])], 1)]), _vm._v(" "), _c('input', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ({
          required: true
        }),
        expression: "{required: true}"
      }, {
        name: "model",
        rawName: "v-model",
        value: (deposit['Deposit_Amount']),
        expression: "deposit['Deposit_Amount']"
      }],
      staticClass: "form-control",
      class: {
        'form-control': true,
        'error': _vm.errors.has('Deposit_Amount' + index)
      },
      staticStyle: {
        "margin-right": "0px"
      },
      attrs: {
        "disabled": !_vm.isFnF,
        "type": "text",
        "name": 'Deposit_Amount' + index,
        "placeholder": "Enter Deposit Amount",
        "onkeypress": "return event.charCode >= 48 && event.charCode <= 57||event.keyCode == 8"
      },
      domProps: {
        "value": (deposit['Deposit_Amount'])
      },
      on: {
        "change": _vm.changeDepType,
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(deposit, 'Deposit_Amount', $event.target.value)
        }
      }
    }), _vm._v(" "), _vm._m(3, true)]), _vm._v(" "), _c('span', {
      staticClass: "text",
      staticStyle: {
        "font-size": "0.8rem",
        "color": "#5D5D5D"
      }
    }, [_vm._v("Note: For deposit amount, please enter denomination details.")]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.errors.has('Deposit_Amount' + index)),
        expression: "errors.has('Deposit_Amount'  + index)"
      }],
      staticClass: "text-danger",
      attrs: {
        "id": 'd_a' + index
      }
    }, [_c('br'), _vm._v("Deposit amount is required. ")])]), _vm._v(" "), (!_vm.isFnF) ? _c('div', {
      staticClass: "form-group"
    }, [_c('div', {
      staticClass: "input-group"
    }, [_c('div', {
      staticClass: "input-group-prepend",
      staticStyle: {
        "width": "140px"
      }
    }, [_c('span', {
      staticClass: "input-group-text",
      staticStyle: {
        "width": "140px"
      }
    }, [_vm._v("Deposit Type "), _c('font', {
      attrs: {
        "color": "red"
      }
    }, [_vm._v(" *")])], 1)]), _vm._v(" "), _c('select', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ({
          required: true
        }),
        expression: "{required: true}"
      }, {
        name: "model",
        rawName: "v-model",
        value: (deposit['DepositType']),
        expression: "deposit['DepositType']"
      }],
      staticClass: "form-control",
      class: {
        'form-control': true,
        'error': _vm.errors.has('DepositType' + index)
      },
      staticStyle: {
        "margin-right": "-3px"
      },
      attrs: {
        "name": 'DepositType' + index
      },
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(deposit, 'DepositType', $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, function($event) {
          _vm.GetBankData(index)
        }]
      }
    }, [_c('option', {
      attrs: {
        "value": ""
      }
    }, [_vm._v("--Select--")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "1"
      }
    }, [_vm._v("Bank (Self) Deposit")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "2"
      }
    }, [_vm._v("CMS (Cash) Deposit")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "3"
      }
    }, [_vm._v("NEFT/Virtual/Other")])]), _vm._v(" "), _vm._m(4, true)]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.errors.has('DepositType' + index)),
        expression: "errors.has('DepositType'  + index)"
      }],
      staticClass: "text-danger"
    }, [_vm._v("Deposit type is required.  ")])]) : _vm._e(), _vm._v(" "), (!_vm.isFnF) ? _c('div', {
      staticClass: "form-group"
    }, [_c('div', {
      staticClass: "input-group"
    }, [_c('div', {
      staticClass: "input-group-prepend",
      staticStyle: {
        "width": "140px"
      }
    }, [_c('span', {
      staticClass: "input-group-text",
      staticStyle: {
        "width": "140px"
      }
    }, [_vm._v("Bank Name "), _c('font', {
      attrs: {
        "color": "red"
      }
    }, [_vm._v(" *")])], 1)]), _vm._v(" "), _c('vue-element-loading', {
      attrs: {
        "spinner": "mini-spinner",
        "color": "#FF6700",
        "active": _vm.bankLoading[index]
      },
      on: {
        "update:active": function($event) {
          _vm.$set(_vm.bankLoading, index, $event)
        }
      }
    }), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (deposit['BankMasterId']),
        expression: "deposit['BankMasterId']"
      }, {
        name: "validate",
        rawName: "v-validate",
        value: ({
          required: true
        }),
        expression: "{required: true}"
      }],
      staticClass: "form-control",
      class: {
        'form-control': true,
        'error': _vm.errors.has('BankMasterId' + index)
      },
      staticStyle: {
        "margin-right": "-8px"
      },
      attrs: {
        "name": 'BankMasterId' + index
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(deposit, 'BankMasterId', $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, [_c('option', {
      attrs: {
        "value": ""
      }
    }, [_vm._v("--Select--")]), _vm._v(" "), _vm._l((deposit['BankList']), function(Bank_obj) {
      return _c('option', {
        domProps: {
          "value": Bank_obj.BankMasterId
        }
      }, [_vm._v(_vm._s(Bank_obj.BankName))])
    })], 2), _vm._v(" "), _vm._m(5, true)], 1), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.errors.has('BankMasterId' + index)),
        expression: "errors.has('BankMasterId' + index)"
      }],
      staticClass: "text-danger"
    }, [_vm._v("Bank name is required.")])]) : _vm._e(), _vm._v(" "), (!_vm.isFnF) ? _c('div', {
      staticClass: "form-group"
    }, [_c('div', {
      staticClass: "input-group"
    }, [_c('div', {
      staticClass: "input-group-prepend",
      staticStyle: {
        "width": "190px",
        "margin-left": "-5px"
      }
    }, [_c('span', {
      staticClass: "input-group-text",
      staticStyle: {
        "width": "190px"
      }
    }, [_vm._v("UTR/NEFT/Transaction Id "), _c('font', {
      attrs: {
        "color": "red"
      }
    }, [_vm._v(" *")])], 1)]), _vm._v(" "), _c('input', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ({
          required: true
        }),
        expression: "{required: true}"
      }, {
        name: "model",
        rawName: "v-model",
        value: (deposit['TransactionID']),
        expression: "deposit['TransactionID']"
      }],
      staticClass: "form-control",
      class: {
        'form-control': true,
        'error': _vm.errors.has('TransactionID' + index)
      },
      staticStyle: {
        "margin-right": "-5px",
        "padding-left": "-5px"
      },
      attrs: {
        "type": "text",
        "name": 'TransactionID' + index,
        "placeholder": "Enter UTR/NEFT/Transaction Id"
      },
      domProps: {
        "value": (deposit['TransactionID'])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(deposit, 'TransactionID', $event.target.value)
        }
      }
    }), _vm._v(" "), _vm._m(6, true)]), _vm._v(" "), _c('span', {
      staticClass: "text",
      staticStyle: {
        "font-size": "0.8rem",
        "color": "#5D5D5D"
      }
    }, [_vm._v("Note: Enter comma (,) separated UTR/NEFT/Transaction Ids.")]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.errors.has('TransactionID' + index)),
        expression: "errors.has('TransactionID' + index)"
      }],
      staticClass: "text-danger"
    }, [_c('br'), _vm._v("UTR/NEFT/Transaction Id is required.")])]) : _vm._e(), _vm._v(" "), (_vm.exceptionList.length > 0 && !_vm.isFnF) ? _c('div', {
      staticClass: "form-group"
    }, [_c('div', {
      staticClass: "input-group"
    }, [_vm._m(7, true), _vm._v(" "), _c('vue-element-loading', {
      attrs: {
        "spinner": "mini-spinner",
        "color": "#FF6700",
        "active": _vm.exceptionLoading
      },
      on: {
        "update:active": function($event) {
          _vm.exceptionLoading = $event
        }
      }
    }), _vm._v(" "), _c('Multiselect', {
      staticStyle: {
        "border": "1px solid #c2cfd6",
        "z-index": "999"
      },
      attrs: {
        "disabled": "",
        "options": _vm.exceptionList,
        "name": 'exception' + index,
        "placeholder": "Select AWB No",
        "label": "ShippingID",
        "track-by": "ShippingID",
        "optionHeight": 100,
        "preselect-first": false,
        "multiple": _vm.multiple(),
        "hide-selected": true
      },
      on: {
        "input": _vm.addExceptionData
      },
      model: {
        value: (deposit['exception']),
        callback: function($$v) {
          _vm.$set(deposit, 'exception', $$v)
        },
        expression: "deposit['exception']"
      }
    }, [_c('template', {
      slot: "noResult"
    }, [_c('p', [_vm._v("No Record Found.")])])], 2), _vm._v(" "), _vm._m(8, true)], 1)]) : _vm._e(), _vm._v(" "), (_vm.exceptionList.length > 0 && !_vm.isFnF) ? _c('div', {
      staticClass: "form-group"
    }, [_c('div', {
      staticClass: "input-group"
    }, [_vm._m(9, true), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (deposit['exceptionAmount']),
        expression: "deposit['exceptionAmount']"
      }],
      staticClass: "form-control",
      class: {
        'form-control': true
      },
      staticStyle: {
        "margin-right": "1px"
      },
      attrs: {
        "disabled": "",
        "type": "text",
        "ame": 'exceptionAmount' + index,
        "placeholder": "Enter Exception Amount"
      },
      domProps: {
        "value": (deposit['exceptionAmount'])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(deposit, 'exceptionAmount', $event.target.value)
        }
      }
    }), _vm._v(" "), _vm._m(10, true)])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "form-group"
    }, [_c('vue-element-loading', {
      attrs: {
        "spinner": "mini-spinner",
        "color": "#FF6700",
        "active": _vm.DepositLoading
      },
      on: {
        "update:active": function($event) {
          _vm.DepositLoading = $event
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "input-group"
    }, [_c('div', {
      staticClass: "input-group-prepend",
      staticStyle: {
        "width": "140px"
      }
    }, [_c('span', {
      staticClass: "input-group-text",
      staticStyle: {
        "width": "140px"
      }
    }, [_vm._v("Deposit Slip "), _c('font', {
      attrs: {
        "color": "red"
      }
    }, [_vm._v(" *")])], 1)]), _vm._v(" "), _c('input', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: (("" + (deposit['uploadFileList'].length<=0 ? 'required' : ''))),
        expression: "`${deposit['uploadFileList'].length<=0 ? 'required' : ''}`"
      }],
      staticClass: "form-control",
      class: {
        'form-control': true,
        'error': _vm.errors.has('DepositSlip' + index)
      },
      staticStyle: {
        "margin": "0px 1px 0px",
        "height": "40px",
        "border": "0"
      },
      attrs: {
        "disabled": deposit['uploadFileList'].length > 0,
        "type": "file",
        "placeholder": "Upload Deposit Slip",
        "name": 'DepositSlip' + index
      },
      on: {
        "change": function($event) {
          _vm.onUpload(index, $event)
        }
      }
    }), _vm._v(" "), _vm._m(11, true)]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.errors.has('DepositSlip' + index)),
        expression: "errors.has('DepositSlip' + index)"
      }],
      staticClass: "text-danger",
      attrs: {
        "id": 'dps' + index
      }
    }, [_vm._v("Deposit slip is required.")]), _vm._v(" "), _vm._l((deposit['uploadFileList']), function(file) {
      return _c('a', {
        attrs: {
          "title": ("" + (file.name)),
          "href": ("" + (file.url))
        }
      }, [_c('i', {
        staticClass: "fa fa-download",
        staticStyle: {
          "font-size": "25px",
          "color": "#4b8cbb",
          "margin": "10px 15px 1px 10px"
        },
        attrs: {
          "aria-hidden": "true"
        }
      })])
    })], 2)])])]), _vm._v(" "), _c('div', {
      staticClass: "col-lg-5"
    }, [_c('div', {
      staticClass: "card"
    }, [_c('div', {
      staticClass: "card-header"
    }, [_vm._v("Denomination "), _c('font', {
      attrs: {
        "color": "red"
      }
    }, [_vm._v(" *")])], 1), _vm._v(" "), _c('div', {
      staticClass: "card-body",
      staticStyle: {
        "height": "500px"
      }
    }, [_c('vue-element-loading', {
      attrs: {
        "spinner": "mini-spinner",
        "color": "#FF6700",
        "active": _vm.denomLoading
      },
      on: {
        "update:active": function($event) {
          _vm.denomLoading = $event
        }
      }
    }), _vm._v(" "), _c('table', {
      staticClass: "table table-responsive-sm",
      attrs: {
        "height": "10",
        "id": "denomlist"
      }
    }, [_vm._m(12, true), _vm._v(" "), _c('tbody', [_vm._l((deposit.denominationList), function(data) {
      return _c('tr', [_c('td', {
        staticClass: "notes"
      }, [_vm._v(_vm._s(data.Denomination))]), _vm._v(" "), _c('td', {
        staticClass: "notes"
      }, [_c('input', {
        staticClass: "form-control",
        attrs: {
          "id": ((data.Denomination) + "-" + index),
          "type": "number",
          "min": "0",
          "name": ((data.Denomination) + " - " + index),
          "onkeypress": "return event.charCode >= 48 && event.charCode <= 57"
        },
        on: {
          "change": function($event) {
            _vm.notesCount($event, index, data.Denomination)
          }
        }
      })]), _vm._v(" "), _c('td', {
        staticClass: "notes"
      }, [_c('input', {
        staticClass: "form-control",
        attrs: {
          "id": ("mo" + (data.Denomination) + "-" + index),
          "type": "text",
          "name": 'note_amt' + index,
          "value": "0",
          "disabled": ""
        }
      }), _vm._v(" "), _c('input', {
        staticClass: "form-control",
        attrs: {
          "id": ("moi" + (data.Denomination) + "-" + index),
          "type": "hidden",
          "disabled": ""
        },
        domProps: {
          "value": ("" + (data.DenominationID))
        }
      })])])
    }), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "notes"
    }), _vm._v(" "), _vm._m(13, true), _vm._v(" "), _c('td', {
      staticClass: "notes"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (deposit['tot_amt']),
        expression: "deposit['tot_amt']"
      }],
      staticClass: "form-control",
      attrs: {
        "id": 'tot_amt' + index,
        "type": "text",
        "name": "tot_amt",
        "value": "0",
        "disabled": ""
      },
      domProps: {
        "value": (deposit['tot_amt'])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(deposit, 'tot_amt', $event.target.value)
        }
      }
    })])])], 2)])], 1)])])])])])
  })), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(14), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700",
      "active": _vm.penAmtLoading
    },
    on: {
      "update:active": function($event) {
        _vm.penAmtLoading = $event
      }
    }
  }), _vm._v(" "), _c('table', {
    staticClass: "table table-responsive-sm"
  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("Yesterday")]), _vm._v(" "), _c('td', {
    attrs: {
      "id": "ClosingBalance"
    }
  }, [_c('i', {
    staticClass: "fa fa-rupee"
  }), _vm._v(" " + _vm._s(_vm.yesterdayCODAmt))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Pending")]), _vm._v(" "), _c('td', {
    attrs: {
      "id": "CODAmount"
    }
  }, [_c('i', {
    staticClass: "fa fa-rupee"
  }), _vm._v(" " + _vm._s(_vm.pendingCODAmt))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Exception")]), _vm._v(" "), _c('td', {
    attrs: {
      "id": "ExceptionAmount"
    }
  }, [_c('i', {
    staticClass: "fa fa-rupee"
  }), _vm._v(" " + _vm._s(_vm.exceptionAmount))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Total")]), _vm._v(" "), _c('td', {
    attrs: {
      "id": "TolatCollection"
    }
  }, [_c('i', {
    staticClass: "fa fa-rupee"
  }), _vm._v(" " + _vm._s(_vm.TolatCollection))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Finance o/s")]), _vm._v(" "), _c('td', {
    attrs: {
      "id": "Financeamt"
    }
  }, [_c('i', {
    staticClass: "fa fa-rupee"
  }), _vm._v(" " + _vm._s(_vm.financeoutstanding))])])])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('i', {
    staticClass: "fa fa-align-justify"
  }), _vm._v(" SR Cash Pendencies \n                      "), _c('i', {
    staticClass: "fa fa-download",
    style: ({
      float: 'right',
      marginTop: '5px',
      cursor: _vm.pendingClosureList.length > 0 ? 'pointer' : 'not-allowed',
      color: _vm.pendingClosureList.length > 0 ? 'black' : 'gray'
    }),
    on: {
      "click": function($event) {
        _vm.pendingClosureList.length > 0 && _vm.downloadCSV()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "card-body",
    staticStyle: {
      "padding": "4px"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700",
      "active": _vm.srPenAmtLoading
    },
    on: {
      "update:active": function($event) {
        _vm.srPenAmtLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "max-height": "210px",
      "margin-top": "10px",
      "overflow": "auto"
    }
  }, [_c('table', {
    staticClass: "table table-responsive-sm SR_details"
  }, [_vm._m(15), _vm._v(" "), _c('tbody', [_vm._l((_vm.pendingClosureList), function(item) {
    return _c('tr', {
      key: item.SRID
    }, [_c('td', [_c('a', {
      staticStyle: {
        "color": "black",
        "cursor": "pointer"
      },
      attrs: {
        "href": ("/#/srclosure/" + (item.SRID))
      }
    }, [_vm._v(_vm._s(item.SRName))])]), _vm._v(" "), _c('td', {
      attrs: {
        "id": "ClosingBalance"
      }
    }, [_c('a', {
      staticStyle: {
        "color": "black",
        "cursor": "pointer"
      },
      attrs: {
        "href": ("/#/srclosure/" + (item.SRID))
      }
    }, [_c('i', {
      staticClass: "fa fa-rupee"
    }), _vm._v(" " + _vm._s(item.totalCOD))])])])
  }), _vm._v(" "), (_vm.pendingClosureList.length == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("No records found")])]) : _vm._e()], 2)])]), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', [_vm._m(16), _vm._v(" "), _c('th', {
    staticStyle: {
      "position": "sticky",
      "bottom": "0",
      "background": "white",
      "z-index": "100",
      "padding": "8px"
    }
  }, [_c('i', {
    staticClass: "fa fa-rupee"
  }), _vm._v(" " + _vm._s(_vm.totalSum))])])])])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (!_vm.isFnF) ? _c('div', {
    staticClass: "col-lg-5 block mb-5 ml-1"
  }, [_c('b', [_vm._v(" Add More Deposits "), _c('button', {
    staticClass: "btn btn-sm btn-primary",
    staticStyle: {
      "width": "30px",
      "height": "30px",
      "border-radius": "50%",
      "padding": "0",
      "margin-left": "20px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.addNewDepositSlip
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-body"
  }, [(!_vm.isFnF) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.unmatchedAmt > 0),
      expression: "unmatchedAmt > 0"
    }],
    staticClass: "multiselect"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "input-group-prepend",
    staticStyle: {
      "width": "140px"
    }
  }, [_c('span', {
    staticClass: "input-group-text",
    staticStyle: {
      "width": "140px"
    }
  }, [_vm._v("Reason "), _c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v(" *")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "selectBox",
    on: {
      "click": function($event) {
        _vm.showCheckboxes()
      }
    }
  }, [_vm._m(17), _vm._v(" "), _c('div', {
    staticClass: "overSelect"
  })]), _vm._v(" "), _vm._m(18)]), _vm._v(" "), _c('div', {
    staticClass: "reason_checkboxes",
    attrs: {
      "id": "checkboxes"
    }
  }, _vm._l((_vm.ReasonList), function(Reason_obj) {
    return _c('label', {
      attrs: {
        "for": _vm.setid(Reason_obj.ReasonsID)
      }
    }, [_c('input', {
      attrs: {
        "type": "checkbox",
        "name": "reason",
        "id": _vm.setid(Reason_obj.ReasonsID)
      },
      on: {
        "change": function($event) {
          _vm.showHideReasonField(Reason_obj.ReasonsID)
        }
      }
    }), _vm._v("  " + _vm._s(Reason_obj.Reason))])
  })), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("Note: " + _vm._s(_vm.unmatchedAmt) + " Rs is remaining amount, please select reason.")])]) : _vm._e(), _vm._v(" "), (_vm.unmatchedAmt > 0 && _vm.amoimp && !_vm.isFnF) ? _c('div', {
    staticClass: "form-group reason_options"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "input-group-prepend",
    staticStyle: {
      "width": "140px"
    }
  }, [_c('span', {
    staticClass: "input-group-text",
    staticStyle: {
      "width": "140px"
    }
  }, [_vm._v("Reason Amount "), _c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v(" *")])], 1)]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (("" + (_vm.amoimp ? 'required' : ''))),
      expression: "`${amoimp ? 'required' : ''}`"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.ReasonAmount),
      expression: "ReasonAmount"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('ReasonAmount')
    },
    staticStyle: {
      "margin-right": "-5px"
    },
    attrs: {
      "id": "ReasonAmount",
      "type": "text",
      "name": "ReasonAmount",
      "title": "Enter amount used for tax payment/ imprest",
      "placeholder": "Enter amount used for tax payment/ imprest",
      "onkeypress": "return event.charCode >= 48 && event.charCode <= 57||event.keyCode == 8"
    },
    domProps: {
      "value": (_vm.ReasonAmount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.ReasonAmount = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._m(19)]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('ReasonAmount')),
      expression: "errors.has('ReasonAmount')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Reason amount used for tax payment/ imprest is required.")])]) : _vm._e(), _vm._v(" "), (_vm.unmatchedAmt > 0 && _vm.amoimp && !_vm.isFnF) ? _c('div', {
    staticClass: "form-group reason_options"
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700",
      "active": _vm.ReasonLoading
    },
    on: {
      "update:active": function($event) {
        _vm.ReasonLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "input-group-prepend",
    staticStyle: {
      "width": "140px"
    }
  }, [_c('span', {
    staticClass: "input-group-text",
    staticStyle: {
      "width": "140px"
    }
  }, [_vm._v("Reason Slip "), _c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v(" *")])], 1)]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (("" + ((_vm.amoimp && _vm.reasonFileList.length<=0) ? 'required' : ''))),
      expression: "`${(amoimp && reasonFileList.length<=0) ? 'required' : ''}`"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('ReasonSlip')
    },
    staticStyle: {
      "margin": "0px 1px 0px",
      "height": "40px",
      "border": "0"
    },
    attrs: {
      "disabled": _vm.reasonFileList.length > 0,
      "type": "file",
      "placeholder": "Upload Reason Slip",
      "name": "ReasonSlip",
      "id": "ReasonSlip"
    },
    on: {
      "change": _vm.onUpload
    }
  }), _vm._v(" "), _vm._m(20)]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('ReasonSlip')),
      expression: "errors.has('ReasonSlip')"
    }],
    staticClass: "text-danger",
    attrs: {
      "id": "rss"
    }
  }, [_vm._v("Reason slip used for tax payment/ imprest is required.")]), _vm._v(" "), _vm._l((_vm.reasonFileList), function(file) {
    return _c('a', {
      attrs: {
        "title": ("" + (file.name)),
        "href": ("" + (file.url))
      }
    }, [_c('i', {
      staticClass: "fa fa-download",
      staticStyle: {
        "font-size": "25px",
        "color": "#4b8cbb",
        "margin": "10px 15px 1px 10px"
      },
      attrs: {
        "aria-hidden": "true"
      }
    })])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.unmatchedAmt > 0 && _vm.cariss && !_vm.isFnF) ? _c('div', {
    staticClass: "form-group reason_options"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "input-group-prepend",
    staticStyle: {
      "width": "140px"
    }
  }, [_c('span', {
    staticClass: "input-group-text",
    staticStyle: {
      "width": "140px"
    }
  }, [_vm._v("AWB No. "), _c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v(" *")])], 1)]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (("" + (_vm.cariss ? 'required' : ''))),
      expression: "`${cariss ? 'required' : ''}`"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.carissAWBNo),
      expression: "carissAWBNo"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('carissAWBNo')
    },
    staticStyle: {
      "margin-right": "-5px"
    },
    attrs: {
      "id": "carissAWBNo",
      "type": "text",
      "name": "carissAWBNo",
      "title": "Enter Card AWB number",
      "placeholder": "Card AWB No."
    },
    domProps: {
      "value": (_vm.carissAWBNo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.carissAWBNo = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._m(21)]), _vm._v(" "), _c('span', {
    staticClass: "text",
    staticStyle: {
      "font-size": "0.8rem",
      "color": "#5D5D5D"
    }
  }, [_vm._v("Note: Please enter comma (,) seperated AWB number.")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('carissAWBNo')),
      expression: "errors.has('carissAWBNo')"
    }],
    staticClass: "text-danger",
    attrs: {
      "id": "awb_n"
    }
  }, [_c('br'), _vm._v("Card AWB No. is required.")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.cassnatarr), function(cas, index) {
    return _c('div', {
      staticClass: "reason_options"
    }, [(_vm.unmatchedAmt > 0 && _vm.cassnat && !_vm.isFnF) ? _c('div', {
      staticClass: "form-group"
    }, [_c('div', {
      staticClass: "input-group"
    }, [_c('div', {
      staticClass: "input-group-prepend"
    }, [_c('span', {
      staticClass: "input-group-text"
    }, [_vm._v("SR Name "), _c('font', {
      attrs: {
        "color": "red"
      }
    }, [_vm._v(" *")])], 1)]), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (cas['srId']),
        expression: "cas['srId']"
      }, {
        name: "validate",
        rawName: "v-validate",
        value: ({
          required: true
        }),
        expression: "{required: true}"
      }],
      staticClass: "form-control",
      class: {
        'form-control': true,
        'error': _vm.errors.has('cassnatSRId' + index)
      },
      attrs: {
        "name": 'cassnatSRId' + index
      },
      on: {
        "input": function($event) {
          _vm.srCasChange(index, $event)
        },
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(cas, 'srId', $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, [_c('option', {
      attrs: {
        "value": ""
      }
    }, [_vm._v("--Select--")]), _vm._v(" "), _vm._l((_vm.pendingClosureList), function(SR_obj) {
      return _c('option', {
        domProps: {
          "value": SR_obj.SRID
        }
      }, [_vm._v(_vm._s(SR_obj.SRName))])
    })], 2)]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.errors.has('cassnatSRId' + index)),
        expression: "errors.has('cassnatSRId' + index)"
      }],
      staticClass: "text-danger"
    }, [_vm._v("SR name is required.")])]) : _vm._e(), _vm._v(" "), (_vm.unmatchedAmt > 0 && _vm.cassnat && !_vm.isFnF) ? _c('div', {
      staticClass: "form-group"
    }, [_c('div', {
      staticClass: "input-group"
    }, [_c('div', {
      staticClass: "input-group-prepend"
    }, [_c('span', {
      staticClass: "input-group-text"
    }, [_vm._v("AWB No. "), _c('font', {
      attrs: {
        "color": "red"
      }
    }, [_vm._v(" *")])], 1)]), _vm._v(" "), _c('input', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: (("" + (_vm.cassnat ? 'required' : ''))),
        expression: "`${cassnat ? 'required' : ''}`"
      }, {
        name: "model",
        rawName: "v-model",
        value: (cas['awbNo']),
        expression: "cas['awbNo']"
      }],
      staticClass: "form-control",
      class: {
        'form-control': true,
        'error': _vm.errors.has('cassnatAWBNo' + index)
      },
      staticStyle: {
        "margin-right": "-5px"
      },
      attrs: {
        "type": "text",
        "name": 'cassnatAWBNo' + index,
        "title": "Enter Cash/shipmet snatched by Customer AWB No.",
        "placeholder": "Cash/shipmet snatched by Customer AWB No."
      },
      domProps: {
        "value": (cas['awbNo'])
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(cas, 'awbNo', $event.target.value)
        }, function($event) {
          _vm.cassnatAWBNoError[index] = ''
        }]
      }
    }), _vm._v(" "), _vm._m(22, true)]), _vm._v(" "), _c('span', {
      staticClass: "text",
      staticStyle: {
        "font-size": "0.8rem",
        "color": "#5D5D5D"
      }
    }, [_vm._v("Note: Please enter comma (,) seperated AWB number.")]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.errors.has('cassnatAWBNo' + index)),
        expression: "errors.has('cassnatAWBNo' + index)"
      }],
      staticClass: "text-danger",
      attrs: {
        "id": "awb_n"
      }
    }, [_c('br'), _vm._v("Cash/shipmet snatched by Customer AWB No. is required.")]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.errors.has('cassnatAWBNo' + index) && _vm.cassnatAWBNoError[index]),
        expression: "!errors.has('cassnatAWBNo' + index) && cassnatAWBNoError[index]"
      }],
      staticClass: "text-danger",
      attrs: {
        "id": "awbsize_n"
      }
    }, [_c('br'), _vm._v(_vm._s(_vm.cassnatAWBNoError[index]))])]) : _vm._e(), _vm._v(" "), (_vm.unmatchedAmt > 0 && _vm.cassnat && !_vm.isFnF && index <= 0) ? _c('div', {
      staticClass: "form-group",
      staticStyle: {
        "text-align": "end"
      }
    }, [_c('button', {
      staticClass: "btn btn-sm btn-primary",
      attrs: {
        "type": "button"
      },
      on: {
        "click": _vm.addCassnatSR
      }
    }, [_c('i', {
      staticClass: "fa fa-plus"
    }), _vm._v(" Add SR")])]) : _vm._e(), _vm._v(" "), (_vm.unmatchedAmt > 0 && _vm.cassnat && !_vm.isFnF && index > 0) ? _c('div', {
      staticClass: "form-group",
      staticStyle: {
        "text-align": "end"
      }
    }, [_c('button', {
      staticClass: "btn btn-sm btn-danger",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.removeCassnatSR(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])]) : _vm._e()])
  }), _vm._v(" "), (_vm.unmatchedAmt > 0 && _vm.paychg && !_vm.isFnF) ? _c('div', {
    staticClass: "form-group reason_options"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "input-group-prepend"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("AWB No. "), _c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v(" *")])], 1)]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (("" + (_vm.paychg ? 'required' : ''))),
      expression: "`${paychg ? 'required' : ''}`"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.paychgAWBNo),
      expression: "paychgAWBNo"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('paychgAWBNo')
    },
    staticStyle: {
      "margin-right": "-5px"
    },
    attrs: {
      "id": "paychgAWBNo",
      "type": "text",
      "name": "paychgAWBNo",
      "title": "Enter Payment Mode Changed AWB No.",
      "placeholder": "Payment Mode Changed AWB No."
    },
    domProps: {
      "value": (_vm.paychgAWBNo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.paychgAWBNo = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._m(23)]), _vm._v(" "), _c('span', {
    staticClass: "text",
    staticStyle: {
      "font-size": "0.8rem",
      "color": "#5D5D5D"
    }
  }, [_vm._v("Note: Please enter comma (,) seperated AWB number.")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('paychgAWBNo')),
      expression: "errors.has('paychgAWBNo')"
    }],
    staticClass: "text-danger",
    attrs: {
      "id": "awb_n"
    }
  }, [_c('br'), _vm._v("Payment Mode Changed AWB No. is required.")])]) : _vm._e(), _vm._v(" "), (_vm.unmatchedAmt > 0 && _vm.vendrec && !_vm.isFnF) ? _c('div', {
    staticClass: "form-group reason_options"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "input-group-prepend"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("AWB No. "), _c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v(" *")])], 1)]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (("" + (_vm.vendrec ? 'required' : ''))),
      expression: "`${vendrec ? 'required' : ''}`"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.vendrecAWBNo),
      expression: "vendrecAWBNo"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('vendrecAWBNo')
    },
    staticStyle: {
      "margin-right": "-5px"
    },
    attrs: {
      "id": "vendrecAWBNo",
      "type": "text",
      "name": "vendrecAWBNo",
      "title": "Enter Vendor Recovery AWB No.",
      "placeholder": "Vendor Recovery AWB No."
    },
    domProps: {
      "value": (_vm.vendrecAWBNo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.vendrecAWBNo = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._m(24)]), _vm._v(" "), _c('span', {
    staticClass: "text",
    staticStyle: {
      "font-size": "0.8rem",
      "color": "#5D5D5D"
    }
  }, [_vm._v("Note: Please enter comma (,) seperated AWB number.")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('vendrecAWBNo')),
      expression: "errors.has('vendrecAWBNo')"
    }],
    staticClass: "text-danger",
    attrs: {
      "id": "awb_n"
    }
  }, [_c('br'), _vm._v("Vendor Recovery AWB No. is required.")])]) : _vm._e(), _vm._v(" "), (_vm.unmatchedAmt > 0 && _vm.casstol && !_vm.isFnF) ? _c('div', {
    staticClass: "form-group reason_options"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "input-group-prepend"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("AWB No. "), _c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v(" *")])], 1)]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (("" + (_vm.casstol ? 'required' : ''))),
      expression: "`${casstol ? 'required' : ''}`"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.casstolAWBNo),
      expression: "casstolAWBNo"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('casstolAWBNo')
    },
    staticStyle: {
      "margin-right": "-5px"
    },
    attrs: {
      "id": "casstolAWBNo",
      "type": "text",
      "name": "casstolAWBNo",
      "title": "Enter Cash stolen by unidentified party AWB No.",
      "placeholder": "Cash stolen by unidentified party AWB No."
    },
    domProps: {
      "value": (_vm.casstolAWBNo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.casstolAWBNo = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._m(25)]), _vm._v(" "), _c('span', {
    staticClass: "text",
    staticStyle: {
      "font-size": "0.8rem",
      "color": "#5D5D5D"
    }
  }, [_vm._v("Note: Please enter comma (,) seperated AWB number.")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('casstolAWBNo')),
      expression: "errors.has('casstolAWBNo')"
    }],
    staticClass: "text-danger",
    attrs: {
      "id": "awb_n"
    }
  }, [_c('br'), _vm._v("Cash stolen by unidentified party AWB No. is required.")])]) : _vm._e(), _vm._v(" "), (_vm.unmatchedAmt > 0 && _vm.theftstol && !_vm.isFnF) ? _c('div', {
    staticClass: "form-group reason_options"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "input-group-prepend"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("AWB No. "), _c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v(" *")])], 1)]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (("" + (_vm.theftstol ? 'required' : ''))),
      expression: "`${theftstol ? 'required' : ''}`"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.theftstolAWBNo),
      expression: "theftstolAWBNo"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('theftstolAWBNo')
    },
    staticStyle: {
      "margin-right": "-5px"
    },
    attrs: {
      "id": "theftstolAWBNo",
      "type": "text",
      "name": "theftstolAWBNo",
      "title": "Enter Theft/Stolen cases AWB No.",
      "placeholder": "Theft/Stolen cases AWB No."
    },
    domProps: {
      "value": (_vm.theftstolAWBNo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.theftstolAWBNo = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._m(26)]), _vm._v(" "), _c('span', {
    staticClass: "text",
    staticStyle: {
      "font-size": "0.8rem",
      "color": "#5D5D5D"
    }
  }, [_vm._v("Note: Please enter comma (,) seperated AWB number.")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('theftstolAWBNo')),
      expression: "errors.has('theftstolAWBNo')"
    }],
    staticClass: "text-danger",
    attrs: {
      "id": "awb_n"
    }
  }, [_c('br'), _vm._v("Theft/Stolen cases AWB No. is required.")])]) : _vm._e(), _vm._v(" "), (_vm.unmatchedAmt > 0 && _vm.wrongdel && !_vm.isFnF) ? _c('div', {
    staticClass: "form-group reason_options"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "input-group-prepend"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("AWB No. "), _c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v(" *")])], 1)]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (("" + (_vm.wrongdel ? 'required' : ''))),
      expression: "`${wrongdel ? 'required' : ''}`"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.wrongdelAWBNo),
      expression: "wrongdelAWBNo"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('wrongdelAWBNo')
    },
    staticStyle: {
      "margin-right": "-5px"
    },
    attrs: {
      "id": "wrongdelAWBNo",
      "type": "text",
      "name": "wrongdelAWBNo",
      "title": "Enter Wrong Delivered Shipments AWB No.",
      "placeholder": "Wrong Delivered Shipments AWB No."
    },
    domProps: {
      "value": (_vm.wrongdelAWBNo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.wrongdelAWBNo = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._m(27)]), _vm._v(" "), _c('span', {
    staticClass: "text",
    staticStyle: {
      "font-size": "0.8rem",
      "color": "#5D5D5D"
    }
  }, [_vm._v("Note: Please enter comma (,) seperated AWB number.")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('wrongdelAWBNo')),
      expression: "errors.has('wrongdelAWBNo')"
    }],
    staticClass: "text-danger",
    attrs: {
      "id": "awb_n"
    }
  }, [_c('br'), _vm._v("Wrong Delivered Shipments AWB No. is required.")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.srabscarr), function(srs, index) {
    return _c('div', {
      staticClass: "reason_options"
    }, [(_vm.unmatchedAmt > 0 && _vm.srabsc && !_vm.isFnF) ? _c('div', {
      staticClass: "form-group"
    }, [_c('div', {
      staticClass: "input-group"
    }, [_c('div', {
      staticClass: "input-group-prepend"
    }, [_c('span', {
      staticClass: "input-group-text"
    }, [_vm._v("AWB No. "), _c('font', {
      attrs: {
        "color": "red"
      }
    }, [_vm._v(" *")])], 1)]), _vm._v(" "), _c('input', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ({
          required: _vm.srabsc
        }),
        expression: "{ required: srabsc }"
      }, {
        name: "model",
        rawName: "v-model",
        value: (srs['awbNo']),
        expression: "srs['awbNo']"
      }],
      staticClass: "form-control",
      class: {
        'form-control': true,
        'error': _vm.errors.has('srabscAWBNo' + index)
      },
      staticStyle: {
        "margin-right": "-5px"
      },
      attrs: {
        "type": "text",
        "name": 'srabscAWBNo' + index,
        "title": "Enter SR absconding AWB No.",
        "placeholder": "SR absconding AWB No."
      },
      domProps: {
        "value": (srs['awbNo'])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(srs, 'awbNo', $event.target.value)
        }
      }
    }), _vm._v(" "), _vm._m(28, true)]), _vm._v(" "), _c('span', {
      staticClass: "text",
      staticStyle: {
        "font-size": "0.8rem",
        "color": "#5D5D5D"
      }
    }, [_vm._v("Note: Please enter comma (,) seperated AWB number.")]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.errors.has('srabscAWBNo' + index)),
        expression: "errors.has('srabscAWBNo' + index)"
      }],
      staticClass: "text-danger",
      attrs: {
        "id": "awb_n"
      }
    }, [_c('br'), _vm._v("SR absconding AWB No. is required.")])]) : _vm._e()])
  }), _vm._v(" "), (_vm.unmatchedAmt > 0 && _vm.lowdis && !_vm.isFnF) ? _c('div', {
    staticClass: "form-group reason_options"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "input-group-prepend"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("Amount "), _c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v(" *")])], 1)]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (("" + (_vm.lowdis ? 'required' : ''))),
      expression: "`${lowdis ? 'required' : ''}`"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.lowdisAmt),
      expression: "lowdisAmt"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('lowdisAmt')
    },
    staticStyle: {
      "margin-right": "-5px"
    },
    attrs: {
      "type": "text",
      "name": "lowdisAmt",
      "title": "Enter Lower Denomination amount",
      "placeholder": "Enter Lower Denomination amount",
      "max": 1000,
      "onkeypress": "return event.charCode >= 48 && event.charCode <= 57||event.keyCode == 8"
    },
    domProps: {
      "value": (_vm.lowdisAmt)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.lowdisAmt = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._m(29)]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('lowdisAmt')),
      expression: "errors.has('lowdisAmt')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Lower Denomination amount is required.")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.lowdisAmt > 1000),
      expression: "lowdisAmt > 1000"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Amount cannot exceed 1000.")])]) : _vm._e(), _vm._v(" "), (_vm.unmatchedAmt > 0 && _vm.fintech && !_vm.isFnF) ? _c('div', {
    staticClass: "form-group reason_options"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "input-group-prepend"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("Amount "), _c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v(" *")])], 1)]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (("" + (_vm.fintech ? 'required' : ''))),
      expression: "`${fintech ? 'required' : ''}`"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.fintechAmt),
      expression: "fintechAmt"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('fintechAmt')
    },
    staticStyle: {
      "margin-right": "-5px"
    },
    attrs: {
      "type": "text",
      "name": "fintechAmt",
      "title": "Enter Fintech wallet amount",
      "placeholder": "Enter Fintech wallet amount",
      "max": 1000,
      "onkeypress": "return event.charCode >= 48 && event.charCode <= 57||event.keyCode == 8"
    },
    domProps: {
      "value": (_vm.fintechAmt)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fintechAmt = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._m(30)]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('fintechAmt')),
      expression: "errors.has('fintechAmt')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Fintech wallet amount is required.")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fintechAmt >= 10001),
      expression: "fintechAmt >=10001"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Amount cannot exceed 10000.")])]) : _vm._e(), _vm._v(" "), (_vm.unmatchedAmt > 0 && _vm.codRot && !_vm.isFnF) ? _c('div', {
    staticClass: "form-group reason_options"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "input-group-prepend"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("Amount "), _c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v(" *")])], 1)]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (("" + (_vm.codRot ? 'required' : ''))),
      expression: "`${codRot ? 'required' : ''}`"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.codRotAmt),
      expression: "codRotAmt"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('codRotAmt')
    },
    staticStyle: {
      "margin-right": "-5px"
    },
    attrs: {
      "type": "text",
      "name": "codRotAmt",
      "title": "Enter COD Rotation amount",
      "placeholder": "Enter COD Rotation amount",
      "max": 1000,
      "onkeypress": "return event.charCode >= 48 && event.charCode <= 57||event.keyCode == 8"
    },
    domProps: {
      "value": (_vm.codRotAmt)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.codRotAmt = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._m(31)]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('codRotAmt')),
      expression: "errors.has('codRotAmt')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("COD Rotation amount is required.")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.srtpsrarr), function(srtp, index) {
    return _c('div', {
      staticClass: "reason_options"
    }, [(_vm.unmatchedAmt > 0 && _vm.srtpsr && !_vm.isFnF) ? _c('div', {
      staticClass: "form-group"
    }, [_c('div', {
      staticClass: "input-group"
    }, [_c('div', {
      staticClass: "input-group-prepend"
    }, [_c('span', {
      staticClass: "input-group-text"
    }, [_vm._v("Amount "), _c('font', {
      attrs: {
        "color": "red"
      }
    }, [_vm._v(" *")])], 1)]), _vm._v(" "), _c('input', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: (("" + (_vm.srtpsr ? 'required' : ''))),
        expression: "`${srtpsr ? 'required' : ''}`"
      }, {
        name: "model",
        rawName: "v-model",
        value: (srtp['srAmt']),
        expression: "srtp['srAmt']"
      }],
      staticClass: "form-control",
      class: {
        'form-control': true,
        'error': _vm.errors.has('srtpsrAmt' + index)
      },
      staticStyle: {
        "margin-right": "-5px"
      },
      attrs: {
        "type": "text",
        "name": 'srtpsrAmt' + index,
        "title": "Enter short payment by SR amount",
        "placeholder": "Short payment by SR amount",
        "onkeypress": "return event.charCode >= 48 && event.charCode <= 57||event.keyCode == 8"
      },
      domProps: {
        "value": (srtp['srAmt'])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(srtp, 'srAmt', $event.target.value)
        }
      }
    }), _vm._v(" "), _vm._m(32, true)]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.errors.has('srtpsrAmt' + index)),
        expression: "errors.has('srtpsrAmt' + index)"
      }],
      staticClass: "text-danger"
    }, [_vm._v("Short payment by SR amount is required.")])]) : _vm._e(), _vm._v(" "), (_vm.unmatchedAmt > 0 && _vm.srtpsr && !_vm.isFnF) ? _c('div', {
      staticClass: "form-group"
    }, [_c('div', {
      staticClass: "input-group"
    }, [_c('div', {
      staticClass: "input-group-prepend"
    }, [_c('span', {
      staticClass: "input-group-text"
    }, [_vm._v("SR Name "), _c('font', {
      attrs: {
        "color": "red"
      }
    }, [_vm._v(" *")])], 1)]), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (srtp['srId']),
        expression: "srtp['srId']"
      }, {
        name: "validate",
        rawName: "v-validate",
        value: ({
          required: true
        }),
        expression: "{required: true}"
      }],
      staticClass: "form-control",
      class: {
        'form-control': true,
        'error': _vm.errors.has('srtpSRId' + index)
      },
      attrs: {
        "name": 'srtpSRId' + index
      },
      on: {
        "input": function($event) {
          _vm.srtpSrChange(index, $event)
        },
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(srtp, 'srId', $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, [_c('option', {
      attrs: {
        "value": ""
      }
    }, [_vm._v("--Select--")]), _vm._v(" "), _vm._l((_vm.srtpsrPendingClosureList), function(SR_obj) {
      return _c('option', {
        domProps: {
          "value": SR_obj.SRID
        }
      }, [_vm._v(_vm._s(SR_obj.SRName))])
    })], 2)]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.errors.has('srtpSRId' + index)),
        expression: "errors.has('srtpSRId' + index)"
      }],
      staticClass: "text-danger"
    }, [_vm._v("SR name is required.")])]) : _vm._e(), _vm._v(" "), (srtp['srId'] == '0000') ? _c('div', {
      staticClass: "form-group"
    }, [_c('div', {
      staticClass: "input-group"
    }, [_c('div', {
      staticClass: "input-group-prepend"
    }, [_c('span', {
      staticClass: "input-group-text"
    }, [_vm._v("Comment "), _c('font', {
      attrs: {
        "color": "red"
      }
    }, [_vm._v(" *")])], 1)]), _vm._v(" "), _c('input', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: (("" + (srtp['srId'] == '0000' ? 'required|max:50' : ''))),
        expression: "`${srtp['srId'] == '0000' ? 'required|max:50' : ''}`"
      }, {
        name: "model",
        rawName: "v-model",
        value: (srtp['comment']),
        expression: "srtp['comment']"
      }],
      staticClass: "form-control",
      class: {
        'form-control': true,
        'error': _vm.errors.has('srtpsrcmt' + index)
      },
      staticStyle: {
        "margin-right": "-5px"
      },
      attrs: {
        "type": "text",
        "name": 'srtpsrcmt' + index,
        "title": "Enter comment",
        "placeholder": "Enter SR Name and SR Emp Id",
        "maxlength": "50"
      },
      domProps: {
        "value": (srtp['comment'])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(srtp, 'comment', $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.errors.has('srtpsrcmt' + index)),
        expression: "errors.has('srtpsrcmt' + index)"
      }],
      staticClass: "text-danger"
    }, [_vm._v("Short payment by SR comment is required.")])]) : _vm._e(), _vm._v(" "), (_vm.unmatchedAmt > 0 && _vm.srtpsr && !_vm.isFnF && index <= 0) ? _c('div', {
      staticClass: "form-group",
      staticStyle: {
        "text-align": "end"
      }
    }, [_c('button', {
      staticClass: "btn btn-sm btn-primary",
      attrs: {
        "type": "button"
      },
      on: {
        "click": _vm.addSrtpNewSR
      }
    }, [_c('i', {
      staticClass: "fa fa-plus"
    }), _vm._v(" Add SR")])]) : _vm._e(), _vm._v(" "), (_vm.unmatchedAmt > 0 && _vm.srtpsr && !_vm.isFnF && index > 0) ? _c('div', {
      staticClass: "form-group",
      staticStyle: {
        "text-align": "end"
      }
    }, [_c('button', {
      staticClass: "btn btn-sm btn-danger",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.removeSrtpSR(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])]) : _vm._e()])
  }), _vm._v(" "), (_vm.unmatchedAmt > 0 && _vm.nddiss && !_vm.isFnF) ? _c('div', {
    staticClass: "form-group reason_options"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "input-group-prepend"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("AWB No. "), _c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v(" *")])], 1)]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (("" + (_vm.nddiss ? 'required' : ''))),
      expression: "`${nddiss ? 'required' : ''}`"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.nddissAWBNo),
      expression: "nddissAWBNo"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('nddissAWBNo')
    },
    attrs: {
      "id": "nddissAWBNo",
      "type": "text",
      "name": "nddissAWBNo",
      "title": "Enter Non-Delivery dispute AWB number",
      "placeholder": "Non-Delivery dispute AWB No."
    },
    domProps: {
      "value": (_vm.nddissAWBNo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.nddissAWBNo = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "text",
    staticStyle: {
      "font-size": "0.8rem",
      "color": "#5D5D5D"
    }
  }, [_vm._v("Note: Please enter comma (,) seperated AWB number.")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('nddissAWBNo')),
      expression: "errors.has('nddissAWBNo')"
    }],
    staticClass: "text-danger",
    attrs: {
      "id": "awb_n"
    }
  }, [_c('br'), _vm._v("Non-Delivery dispute AWB No. is required.")])]) : _vm._e(), _vm._v(" "), (_vm.unmatchedAmt > 0 && _vm.waliss && !_vm.isFnF) ? _c('div', {
    staticClass: "form-group reason_options"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "input-group-prepend"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("AWB No. "), _c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v(" *")])], 1)]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (("" + (_vm.waliss ? 'required' : ''))),
      expression: "`${waliss ? 'required' : ''}`"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.walissAWBNo),
      expression: "walissAWBNo"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('walissAWBNo')
    },
    attrs: {
      "id": "walissAWBNo",
      "type": "text",
      "name": "walissAWBNo",
      "title": "Enter Wallet AWB number",
      "placeholder": "Wallet AWB No."
    },
    domProps: {
      "value": (_vm.walissAWBNo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.walissAWBNo = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "text",
    staticStyle: {
      "font-size": "0.8rem",
      "color": "#5D5D5D"
    }
  }, [_vm._v("Note: Please enter comma (,) seperated AWB number.")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('walissAWBNo')),
      expression: "errors.has('walissAWBNo')"
    }],
    staticClass: "text-danger",
    attrs: {
      "id": "awb_n"
    }
  }, [_vm._v("Wallet AWB No. is required.")])]) : _vm._e(), _vm._v(" "), (_vm.unmatchedAmt > 0 && _vm.paypiss && !_vm.isFnF) ? _c('div', {
    staticClass: "form-group reason_options"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "input-group-prepend"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("AWB No. "), _c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v(" *")])], 1)]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (("" + (_vm.paypiss ? 'required' : ''))),
      expression: "`${paypiss ? 'required' : ''}`"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.paypissAWBNo),
      expression: "paypissAWBNo"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('paypissAWBNo')
    },
    attrs: {
      "id": "paypissAWBNo",
      "type": "text",
      "name": "paypissAWBNo",
      "title": "Enter Payphi AWB number",
      "placeholder": "Payphi AWB No."
    },
    domProps: {
      "value": (_vm.paypissAWBNo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.paypissAWBNo = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "text",
    staticStyle: {
      "font-size": "0.8rem",
      "color": "#5D5D5D"
    }
  }, [_vm._v("Note: Please enter comma (,) seperated AWB number.")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('paypissAWBNo')),
      expression: "errors.has('paypissAWBNo')"
    }],
    staticClass: "text-danger",
    attrs: {
      "id": "awb_n"
    }
  }, [_vm._v("Payphi AWB No. is required.")])]) : _vm._e(), _vm._v(" "), (_vm.unmatchedAmt > 0 && _vm.srtptsvc && !_vm.isFnF) ? _c('div', {
    staticClass: "form-group reason_options"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "input-group-prepend"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("Amount "), _c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v(" *")])], 1)]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (("" + (_vm.srtptsvc ? 'required' : ''))),
      expression: "`${srtptsvc ? 'required' : ''}`"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.srtptsvcAmt),
      expression: "srtptsvcAmt"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('srtptsvcAmt')
    },
    staticStyle: {
      "margin-right": "-5px"
    },
    attrs: {
      "id": "srtptsvcAmt",
      "type": "text",
      "name": "srtptsvcAmt",
      "title": "Enter short payment (theft at SVC) amount",
      "placeholder": "Short Payment (Theft at SVC) Amount",
      "onkeypress": "return event.charCode >= 48 && event.charCode <= 57||event.keyCode == 8"
    },
    domProps: {
      "value": (_vm.srtptsvcAmt)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.srtptsvcAmt = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._m(33)]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('srtptsvcAmt')),
      expression: "errors.has('srtptsvcAmt')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Short payment (theft at SVC) amount is required.")])]) : _vm._e(), _vm._v(" "), (_vm.unmatchedAmt > 0 && _vm.srtptsvc && !_vm.isFnF) ? _c('div', {
    staticClass: "form-group reason_options"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "input-group-prepend",
    staticStyle: {
      "width": "169px"
    }
  }, [_c('span', {
    staticClass: "input-group-text",
    staticStyle: {
      "width": "169px"
    }
  }, [_vm._v("Complaint attachment "), _c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v(" *")])], 1)]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (("" + (_vm.srtptsvcfile.length<=0 ? 'required' : ''))),
      expression: "`${srtptsvcfile.length<=0 ? 'required' : ''}`"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('srtptsvcfile')
    },
    staticStyle: {
      "margin": "0px 1px 0px",
      "height": "40px",
      "border": "0"
    },
    attrs: {
      "disabled": _vm.srtptsvcfile.length > 0,
      "type": "file",
      "placeholder": "Upload Complaint attachment",
      "name": "srtptsvcfile",
      "id": "srtptsvcfile"
    },
    on: {
      "change": _vm.onUploadAttachment
    }
  }), _vm._v(" "), _vm._m(34)]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('srtptsvcfile')),
      expression: "errors.has('srtptsvcfile')"
    }],
    staticClass: "text-danger",
    attrs: {
      "id": "dps"
    }
  }, [_vm._v("Complaint attacment is required.")])]) : _vm._e(), _vm._v(" "), (_vm.unmatchedAmt > 0 && _vm.raziss && !_vm.isFnF) ? _c('div', {
    staticClass: "form-group reason_options"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "input-group-prepend"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("AWB No. "), _c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v(" *")])], 1)]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (("" + (_vm.raziss ? 'required' : ''))),
      expression: "`${raziss ? 'required' : ''}`"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.razissAWBNo),
      expression: "razissAWBNo"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('razissAWBNo')
    },
    attrs: {
      "id": "razissAWBNo",
      "type": "text",
      "name": "razissAWBNo",
      "title": "Enter Razorpay AWB number",
      "placeholder": "Razorpay AWB No."
    },
    domProps: {
      "value": (_vm.razissAWBNo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.razissAWBNo = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "text",
    staticStyle: {
      "font-size": "0.8rem",
      "color": "#5D5D5D"
    }
  }, [_vm._v("Note: Please enter comma (,) seperated AWB number.")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('razissAWBNo')),
      expression: "errors.has('razissAWBNo')"
    }],
    staticClass: "text-danger",
    attrs: {
      "id": "awb_n"
    }
  }, [_vm._v("Razorpay AWB No. is required.")])]) : _vm._e(), _vm._v(" "), (_vm.unmatchedAmt > 0 && _vm.pine && !_vm.isFnF) ? _c('div', {
    staticClass: "form-group reason_options"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "input-group-prepend"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("AWB No. "), _c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v(" *")])], 1)]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (("" + (_vm.pine ? 'required' : ''))),
      expression: "`${pine ? 'required' : ''}`"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.pineAWBNo),
      expression: "pineAWBNo"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('pineAWBNo')
    },
    attrs: {
      "id": "pineAWBNo",
      "type": "text",
      "name": "pineAWBNo",
      "title": "Enter Pinelab AWB number",
      "placeholder": "Pinelab AWB No."
    },
    domProps: {
      "value": (_vm.pineAWBNo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.pineAWBNo = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "text",
    staticStyle: {
      "font-size": "0.8rem",
      "color": "#5D5D5D"
    }
  }, [_vm._v("Note: Please enter comma (,) seperated AWB number.")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('pineAWBNo')),
      expression: "errors.has('pineAWBNo')"
    }],
    staticClass: "text-danger",
    attrs: {
      "id": "awb_n"
    }
  }, [_vm._v("Pinelab AWB No. is required.")])]) : _vm._e(), _vm._v(" "), (_vm.unmatchedAmt > 0 && _vm.habridpi) ? _c('div', {
    staticClass: "form-group reason_options"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "input-group-prepend"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("AWB No. "), _c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v(" *")])], 1)]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (("" + (_vm.habridpi ? 'required' : ''))),
      expression: "`${habridpi ? 'required' : ''}`"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.habridpiAWBNo),
      expression: "habridpiAWBNo"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('habridpiAWBNo')
    },
    attrs: {
      "id": "habridpiAWBNo",
      "type": "text",
      "name": "habridpiAWBNo",
      "title": "Enter Hybrid AWB number",
      "placeholder": "Enter Hybrid AWB"
    },
    domProps: {
      "value": (_vm.habridpiAWBNo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.habridpiAWBNo = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "text",
    staticStyle: {
      "font-size": "0.8rem",
      "color": "#5D5D5D"
    }
  }, [_vm._v("Note: Please enter comma (,) seperated AWB number.")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('habridpiAWBNo')),
      expression: "errors.has('habridpiAWBNo')"
    }],
    staticClass: "text-danger",
    attrs: {
      "id": "awb_n"
    }
  }, [_vm._v("Hybrid AWB No. is required.")])]) : _vm._e(), _vm._v(" "), (_vm.unmatchedAmt > 0 && _vm.habridpi) ? _c('div', {
    staticClass: "form-group reason_options"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "input-group-prepend"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("Amount "), _c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v(" *")])], 1)]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (("" + (_vm.habridpi ? 'required' : ''))),
      expression: "`${habridpi ? 'required' : ''}`"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.habridpiAMT),
      expression: "habridpiAMT"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('habridpiAMT')
    },
    attrs: {
      "id": "habridpiAMT",
      "type": "text",
      "name": "habridpiAMT",
      "title": "Enter Hybrid Dispute Amount",
      "placeholder": "Enter Hybrid Dispute Amount",
      "onkeypress": "return event.charCode >= 48 && event.charCode <= 57||event.keyCode == 8"
    },
    domProps: {
      "value": (_vm.habridpiAMT)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.habridpiAMT = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('habridpiAMT')),
      expression: "errors.has('habridpiAMT')"
    }],
    staticClass: "text-danger",
    attrs: {
      "id": "awb_n"
    }
  }, [_vm._v("Amount is required.")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700",
      "active": _vm.subLoading
    },
    on: {
      "update:active": function($event) {
        _vm.subLoading = $event
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-primary",
    attrs: {
      "disabled": _vm.disableButton,
      "type": "submit"
    }
  }, [_c('i', {
    staticClass: "fa fa-dot-circle-o"
  }), _vm._v(" Save")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-danger",
    attrs: {
      "disabled": _vm.disableButton,
      "type": "reset"
    },
    on: {
      "click": function($event) {
        _vm.resetForm()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" Clear")])], 1)], 2)])]), _vm._v(" "), _c('b-modal', {
    ref: "myModalRef",
    attrs: {
      "id": "#confirmationmodal",
      "title": "Confirmation"
    },
    model: {
      value: (_vm.modalShow),
      callback: function($$v) {
        _vm.modalShow = $$v
      },
      expression: "modalShow"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h5', {
    staticClass: "modal-title"
  }, [_vm._v("Confirmation")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeStatusRoleModal
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('h5', {
    staticStyle: {
      "font-size": "1rem",
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.unmatchedAmt) + " Rs. is remaining amount, please select reason")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footerfrm"
  }, [_c('center', [_c('button', {
    staticClass: "btn btn-success",
    staticStyle: {
      "background-color": "#20a8d8"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.modalShow = false
      }
    }
  }, [_vm._v("Ok")])])], 1)])])]), _vm._v(" "), _c('b-modal', {
    ref: "myConfModalRef",
    attrs: {
      "id": "#confirmationmodal",
      "title": "Confirmation"
    },
    model: {
      value: (_vm.ConfmodalShow),
      callback: function($$v) {
        _vm.ConfmodalShow = $$v
      },
      expression: "ConfmodalShow"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h5', {
    staticClass: "modal-title"
  }, [_vm._v("Confirmation")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeStatusRoleModal
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('h5', {
    staticStyle: {
      "font-size": "1rem",
      "color": "red"
    }
  }, [_vm._v("Are you sure to submit the SVC closure.")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footerfrm"
  }, [_c('center', [_c('button', {
    staticClass: "btn btn-success",
    staticStyle: {
      "background-color": "#20a8d8"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.hideConfModal('0')
      }
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    staticStyle: {
      "background-color": "#f86c6b"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.hideConfModal('1')
      }
    }
  }, [_vm._v("No")])])], 1)])])]), _vm._v(" "), _c('b-modal', {
    ref: "myExModalRef",
    attrs: {
      "id": "#confirmationmodal",
      "title": "Confirmation"
    },
    model: {
      value: (_vm.ExmodalShow),
      callback: function($$v) {
        _vm.ExmodalShow = $$v
      },
      expression: "ExmodalShow"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h5', {
    staticClass: "modal-title"
  }, [_vm._v("Confirmation")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeStatusRoleModal
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('h5', {
    staticStyle: {
      "font-size": "1rem",
      "color": "red"
    }
  }, [_vm._v("Please make sure you have enter extra amount of Rs. " + _vm._s(_vm.ExData))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footerfrm"
  }, [_c('center', [_c('button', {
    staticClass: "btn btn-success",
    staticStyle: {
      "background-color": "#20a8d8"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.hideExModal('0')
      }
    }
  }, [_vm._v("Ok")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    staticStyle: {
      "background-color": "#f86c6b"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.hideExModal('1')
      }
    }
  }, [_vm._v("Cancel")])])], 1)])])]), _vm._v(" "), _c('b-modal', {
    ref: "myCardModalRef",
    attrs: {
      "id": "#confirmationmodal1",
      "title": "Confirmation"
    },
    model: {
      value: (_vm.cardModalShow),
      callback: function($$v) {
        _vm.cardModalShow = $$v
      },
      expression: "cardModalShow"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content",
    staticStyle: {
      "width": "150%"
    }
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h5', {
    staticClass: "modal-title",
    staticStyle: {
      "font-size": "1rem"
    }
  }, [_vm._v("AWB No & AWB Amount Confirmation")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeStatusRoleModal
    }
  }, [_c('span', {
    staticStyle: {
      "color": "white"
    },
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables mb-5",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader",
    staticStyle: {
      "width": "51%"
    }
  }, [_c('b', [_vm._v("Slip No")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    staticStyle: {
      "width": "50%"
    }
  }, [_c('b', [_vm._v("Deposit Amount")])])])]), _vm._v(" "), _c('tbody', [(_vm.depositSlips.length <= 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "3",
      "align": "center"
    }
  }, [_vm._v("No record found")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.depositSlips), function(val, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center",
      staticStyle: {
        "width": "30%"
      }
    }, [_vm._v("COD Closure Deposit " + _vm._s(index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      staticStyle: {
        "width": "50%"
      }
    }, [_vm._v(_vm._s(val.tot_amt))])])
  })], 2)]), _vm._v(" "), _c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader",
    staticStyle: {
      "width": "1%"
    }
  }, [_c('b', [_vm._v("#")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    staticStyle: {
      "width": "30%"
    }
  }, [_c('b', [_vm._v("Reason")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    staticStyle: {
      "width": "60%"
    }
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "margin-left": "18px",
      "margin-right": "3px"
    }
  }, [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader",
    staticStyle: {
      "width": "200px"
    }
  }, [_c('b', [_vm._v("SR Name")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    staticStyle: {
      "width": "159px"
    }
  }, [_c('b', [_vm._v("AWB Number")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    staticStyle: {
      "width": "77px"
    }
  }, [_c('b', [_vm._v("Amount ( "), _c('i', {
    staticClass: "fa fa-rupee"
  }), _vm._v(" )")])])])])])])]), _vm._v(" "), _c('tbody', [(_vm.DisputeArr.length <= 0) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("No record found")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.DisputeArr), function(val, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center",
      staticStyle: {
        "width": "1%"
      }
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      staticStyle: {
        "width": "30%"
      }
    }, [_vm._v(_vm._s(val.Reason))]), _vm._v(" "), (val.SRDetails) ? _c('td', {
      staticClass: "text-center",
      staticStyle: {
        "width": "60%"
      }
    }, [_c('div', {
      staticClass: "flex align-items-center",
      staticStyle: {
        "position": "relative"
      }
    }, [(val.SRDetails.length > 1) ? _c('a', {
      staticClass: "toggle-button",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          _vm.toggleDetails(val.ReasonID)
        }
      }
    }, [(!_vm.expandedRows[val.ReasonID]) ? _c('i', {
      staticClass: "fa fa-chevron-down"
    }) : _c('i', {
      staticClass: "fa fa-chevron-up"
    })]) : _vm._e(), _vm._v(" "), _c('table', {
      staticClass: "table-container",
      staticStyle: {
        "margin-left": "13px"
      }
    }, _vm._l((val.SRDetails), function(srdetails, i) {
      return _c('tr', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: ((i > 0 && _vm.expandedRows[val.ReasonID]) || i == 0),
          expression: "(i > 0 && expandedRows[val.ReasonID]) || i == 0"
        }],
        key: i
      }, [_c('td', {
        staticClass: "text-center",
        staticStyle: {
          "width": "200px"
        }
      }, [_vm._v("\n                                " + _vm._s(srdetails.srName) + " " + _vm._s(srdetails.comment ? ' - ' + srdetails.comment : '') + "\n                              ")]), _vm._v(" "), (!val.ReasonAmt) ? _c('td', [_c('table', _vm._l((_vm.getSRAWBNo(val.awb, srdetails.awbNo)), function(row) {
        return _c('tr', {
          key: row.awbno
        }, [_c('td', {
          staticClass: "text-center",
          staticStyle: {
            "width": "159px"
          }
        }, [_vm._v(_vm._s(row.awbno))]), _vm._v(" "), _c('td', {
          staticClass: "text-center",
          staticStyle: {
            "width": "77px"
          }
        }, [_vm._v(_vm._s(row.amount))])])
      }))]) : _vm._e(), _vm._v(" "), (val.ReasonAmt) ? _c('td', {
        staticClass: "text-center",
        staticStyle: {
          "width": "159px"
        }
      }) : _vm._e(), _vm._v(" "), (val.ReasonAmt) ? _c('td', {
        staticClass: "text-center",
        staticStyle: {
          "width": "77px"
        }
      }, [_vm._v(_vm._s(srdetails.srAmt))]) : _vm._e()])
    }))])]) : (val.ReasonAmt) ? _c('td', {
      staticClass: "text-center",
      staticStyle: {
        "width": "60%"
      }
    }, [_c('table', {
      staticClass: "table-bordered table-hover tbl datatables",
      staticStyle: {
        "margin-left": "13px"
      }
    }, [_c('tr', [_c('td', {
      staticClass: "text-center",
      staticStyle: {
        "width": "200px"
      }
    }), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      staticStyle: {
        "width": "159px"
      }
    }, [_vm._v(_vm._s(val.awb.map(function (x) { return Object.keys(x)[0]; }).join(', ')))]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      staticStyle: {
        "width": "77px"
      }
    }, [_vm._v(_vm._s(val.ReasonAmt))])])])]) : (!val.ReasonAmt) ? _c('td', {
      staticClass: "text-center",
      staticStyle: {
        "width": "60%"
      }
    }, [_c('div', {
      staticClass: "flex align-items-center",
      staticStyle: {
        "position": "relative"
      }
    }, [(val.awb.length > 1) ? _c('a', {
      staticClass: "toggle-button",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          _vm.toggleDetails(val.ReasonID)
        }
      }
    }, [(!_vm.expandedRows[val.ReasonID]) ? _c('i', {
      staticClass: "fa fa-chevron-down"
    }) : _c('i', {
      staticClass: "fa fa-chevron-up"
    })]) : _vm._e(), _vm._v(" "), _c('table', {
      staticClass: "table-container",
      staticStyle: {
        "margin-left": "13px"
      }
    }, _vm._l((val.awb), function(row, i) {
      return _c('tr', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: ((i > 0 && _vm.expandedRows[val.ReasonID]) || i == 0),
          expression: "(i > 0 && expandedRows[val.ReasonID]) || i == 0"
        }],
        key: i
      }, [_c('td', {
        staticClass: "text-center",
        staticStyle: {
          "width": "200px"
        }
      }), _vm._v(" "), _c('td', {
        staticClass: "text-center",
        staticStyle: {
          "width": "159px"
        }
      }, [_vm._v(_vm._s((Object.keys(row)) ? Object.keys(row).toString() : ''))]), _vm._v(" "), _c('td', {
        staticClass: "text-center",
        staticStyle: {
          "width": "77px"
        }
      }, [_vm._v(_vm._s((Object.values(row)) ? Object.values(row).toString() : ''))])])
    }))])]) : _vm._e()])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footerfrm"
  }, [_c('center', [_c('button', {
    staticClass: "btn btn-success",
    staticStyle: {
      "background-color": "#20a8d8"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.hideCardModal('0')
      }
    }
  }, [_vm._v("Ok")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    staticStyle: {
      "background-color": "#f86c6b"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.hideCardModal('1')
      }
    }
  }, [_vm._v("Cancel")])])], 1)])])]), _vm._v(" "), _c('b-modal', {
    ref: "myReasonModalRef",
    attrs: {
      "id": "#confirmationmodal2",
      "title": "Confirmation"
    },
    model: {
      value: (_vm.ReasonModalShow),
      callback: function($$v) {
        _vm.ReasonModalShow = $$v
      },
      expression: "ReasonModalShow"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content",
    staticStyle: {
      "width": "150%"
    }
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h5', {
    staticClass: "modal-title",
    staticStyle: {
      "font-size": "1rem"
    }
  }, [_vm._v("Reason AWB No/Amount")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeStatusRoleModal
    }
  }, [_c('span', {
    staticStyle: {
      "color": "white"
    },
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader",
    staticStyle: {
      "width": "1%"
    }
  }, [_c('b', [_vm._v("#")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    staticStyle: {
      "width": "30%"
    }
  }, [_c('b', [_vm._v("Reason")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    staticStyle: {
      "width": "60%"
    }
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "margin-left": "18px",
      "margin-right": "3px"
    }
  }, [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader",
    staticStyle: {
      "width": "200px"
    }
  }, [_c('b', [_vm._v("SR Name")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    staticStyle: {
      "width": "159px"
    }
  }, [_c('b', [_vm._v("AWB Number")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    staticStyle: {
      "width": "77px"
    }
  }, [_c('b', [_vm._v("Amount ( "), _c('i', {
    staticClass: "fa fa-rupee"
  }), _vm._v(" )")])])])])])])]), _vm._v(" "), _c('tbody', [(_vm.DisputeArr.length <= 0) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("No record found")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.DisputeArr), function(val, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center",
      staticStyle: {
        "width": "1%"
      }
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      staticStyle: {
        "width": "30%"
      }
    }, [_vm._v(_vm._s(val.Reason))]), _vm._v(" "), (val.SRDetails) ? _c('td', {
      staticClass: "text-center",
      staticStyle: {
        "width": "60%"
      }
    }, [_c('div', {
      staticClass: "flex align-items-center",
      staticStyle: {
        "position": "relative"
      }
    }, [(val.SRDetails.length > 1) ? _c('a', {
      staticClass: "toggle-button",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          _vm.toggleDetails(val.ReasonID)
        }
      }
    }, [(!_vm.expandedRows[val.ReasonID]) ? _c('i', {
      staticClass: "fa fa-chevron-down"
    }) : _c('i', {
      staticClass: "fa fa-chevron-up"
    })]) : _vm._e(), _vm._v(" "), _c('table', {
      staticClass: "table-container",
      staticStyle: {
        "margin-left": "13px"
      }
    }, _vm._l((val.SRDetails), function(srdetails, i) {
      return _c('tr', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: ((i > 0 && _vm.expandedRows[val.ReasonID]) || i == 0),
          expression: "(i > 0 && expandedRows[val.ReasonID]) || i == 0"
        }],
        key: i
      }, [_c('td', {
        staticClass: "text-center",
        staticStyle: {
          "width": "200px"
        }
      }, [_vm._v("\n                                " + _vm._s(srdetails.srName) + " " + _vm._s(srdetails.comment ? ' - ' + srdetails.comment : '') + "\n                              ")]), _vm._v(" "), (!val.ReasonAmt) ? _c('td', [_c('table', _vm._l((_vm.getSRAWBNo(val.awb, srdetails.awbNo)), function(row) {
        return _c('tr', {
          key: row.awbno
        }, [_c('td', {
          staticClass: "text-center",
          staticStyle: {
            "width": "159px"
          }
        }, [_vm._v(_vm._s(row.awbno))]), _vm._v(" "), _c('td', {
          staticClass: "text-center",
          staticStyle: {
            "width": "77px"
          }
        }, [_vm._v(_vm._s(row.amount))])])
      }))]) : _vm._e(), _vm._v(" "), (val.ReasonAmt) ? _c('td', {
        staticClass: "text-center",
        staticStyle: {
          "width": "159px"
        }
      }) : _vm._e(), _vm._v(" "), (val.ReasonAmt) ? _c('td', {
        staticClass: "text-center",
        staticStyle: {
          "width": "77px"
        }
      }, [_vm._v(_vm._s(srdetails.srAmt))]) : _vm._e()])
    }))])]) : (val.ReasonAmt) ? _c('td', {
      staticClass: "text-center",
      staticStyle: {
        "width": "60%"
      }
    }, [_c('table', {
      staticClass: "table-bordered table-hover tbl datatables",
      staticStyle: {
        "margin-left": "13px"
      }
    }, [_c('tr', [_c('td', {
      staticClass: "text-center",
      staticStyle: {
        "width": "200px"
      }
    }), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      staticStyle: {
        "width": "159px"
      }
    }, [_vm._v(_vm._s(val.awb.map(function (x) { return Object.keys(x)[0]; }).join(', ')))]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      staticStyle: {
        "width": "77px"
      }
    }, [_vm._v(_vm._s(val.ReasonAmt) + "\n                              "), ((val.ReasonID == 363 || val.ReasonID == 165) && val.ReasonURL != undefined && val.ReasonURL != '') ? _c('a', {
      on: {
        "click": function($event) {
          _vm.generateUrl(val.ReasonURL)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-download",
      staticStyle: {
        "font-size": "15px",
        "color": "#4b8cbb",
        "margin": "0px 0px 0px 10px"
      },
      attrs: {
        "aria-hidden": "true"
      }
    })]) : _vm._e()])])])]) : (!val.ReasonAmt) ? _c('td', {
      staticClass: "text-center",
      staticStyle: {
        "width": "60%"
      }
    }, [_c('div', {
      staticClass: "flex align-items-center",
      staticStyle: {
        "position": "relative"
      }
    }, [(val.awb.length > 1) ? _c('a', {
      staticClass: "toggle-button",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          _vm.toggleDetails(val.ReasonID)
        }
      }
    }, [(!_vm.expandedRows[val.ReasonID]) ? _c('i', {
      staticClass: "fa fa-chevron-down"
    }) : _c('i', {
      staticClass: "fa fa-chevron-up"
    })]) : _vm._e(), _vm._v(" "), _c('table', {
      staticClass: "table-container",
      staticStyle: {
        "margin-left": "13px"
      }
    }, _vm._l((val.awb), function(row, i) {
      return _c('tr', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: ((i > 0 && _vm.expandedRows[val.ReasonID]) || i == 0),
          expression: "(i > 0 && expandedRows[val.ReasonID]) || i == 0"
        }],
        key: i
      }, [_c('td', {
        staticClass: "text-center",
        staticStyle: {
          "width": "200px"
        }
      }), _vm._v(" "), _c('td', {
        staticClass: "text-center",
        staticStyle: {
          "width": "159px"
        }
      }, [_vm._v(_vm._s((Object.keys(row)) ? Object.keys(row).toString() : ''))]), _vm._v(" "), _c('td', {
        staticClass: "text-center",
        staticStyle: {
          "width": "77px"
        }
      }, [_vm._v(_vm._s((Object.values(row)) ? Object.values(row).toString() : ''))])])
    }))])]) : _vm._e()])
  })], 2)])])])])]), _vm._v(" "), _c('b-modal', {
    ref: "myRecExcModalRef",
    attrs: {
      "id": "#confirmationmodal3",
      "title": "Confirmation"
    },
    model: {
      value: (_vm.RecExcModalShow),
      callback: function($$v) {
        _vm.RecExcModalShow = $$v
      },
      expression: "RecExcModalShow"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content",
    staticStyle: {
      "width": "150%"
    }
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h5', {
    staticClass: "modal-title",
    staticStyle: {
      "font-size": "1rem"
    }
  }, [_vm._v("Self Debit/Recovery & Exception AWB No/Amount")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeStatusRoleModal
    }
  }, [_c('span', {
    staticStyle: {
      "color": "white"
    },
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader",
    staticStyle: {
      "width": "1%"
    }
  }, [_c('b', [_vm._v("#")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    staticStyle: {
      "width": "50%"
    }
  }, [_c('b', [_vm._v("Reason")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    staticStyle: {
      "width": "49%"
    }
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables"
  }, [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader",
    staticStyle: {
      "width": "25%"
    }
  }, [_c('b', [_vm._v("AWB Number")])])])])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    staticStyle: {
      "width": "10%"
    }
  }, [_c('b', [_vm._v("Amount ( "), _c('i', {
    staticClass: "fa fa-rupee"
  }), _vm._v(" )")])])])]), _vm._v(" "), _c('tbody', [(_vm.DisputeArr.length <= 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "4",
      "align": "center"
    }
  }, [_vm._v("No record found")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.DisputeArr), function(val, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center",
      staticStyle: {
        "width": "1%"
      }
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      staticStyle: {
        "width": "50%"
      }
    }, [_vm._v(_vm._s(val.Reason))]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      staticStyle: {
        "width": "49%"
      }
    }, [_c('table', {
      staticClass: "table-bordered table-hover tbl datatables"
    }, _vm._l((val.awb), function(row, ind) {
      return _c('tr', [_c('td', {
        staticClass: "text-center",
        staticStyle: {
          "width": "25%"
        }
      }, [_vm._v(_vm._s((Object.keys(row)) ? Object.keys(row).toString() : ''))])])
    }))]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      staticStyle: {
        "width": "11%"
      }
    }, [_vm._v(_vm._s(val.amount))])])
  })], 2)])])])])]), _vm._v(" "), _c('b-modal', {
    ref: "myCommentModalRef",
    attrs: {
      "id": "#confirmationmodal",
      "title": "Confirmation"
    },
    model: {
      value: (_vm.commentModalShow),
      callback: function($$v) {
        _vm.commentModalShow = $$v
      },
      expression: "commentModalShow"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h5', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.cType))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeStatusRoleModal
    }
  }, [_c('span', {
    staticStyle: {
      "color": "white"
    },
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('h5', {
    staticStyle: {
      "font-size": "0.9rem",
      "color": "black"
    }
  }, [_vm._v(_vm._s(_vm.comment))])])])])]), _vm._v(" "), _c('b-modal', {
    ref: "myResetModalRef",
    attrs: {
      "id": "#confirmationmodal",
      "title": "Confirmation"
    },
    model: {
      value: (_vm.ResetmodalShow),
      callback: function($$v) {
        _vm.ResetmodalShow = $$v
      },
      expression: "ResetmodalShow"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h5', {
    staticClass: "modal-title"
  }, [_vm._v("Confirmation")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeStatusRoleModal
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('h5', {
    staticStyle: {
      "font-size": "1rem",
      "color": "red"
    }
  }, [_vm._v("Are you sure to reset SVC closure for delivery date " + _vm._s(_vm.resetDD) + ".")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footerfrm"
  }, [_c('center', [_c('button', {
    staticClass: "btn btn-success",
    staticStyle: {
      "background-color": "#20a8d8"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.hideResetModal('0')
      }
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    staticStyle: {
      "background-color": "#f86c6b"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.hideResetModal('1')
      }
    }
  }, [_vm._v("No")])])], 1)])])]), _vm._v(" "), _c('b-modal', {
    ref: "errorModalRef",
    attrs: {
      "id": "#errormodal",
      "title": "Error"
    },
    model: {
      value: (_vm.errorModalShow),
      callback: function($$v) {
        _vm.errorModalShow = $$v
      },
      expression: "errorModalShow"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h5', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.errorTitle))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeStatusRoleModal
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('h5', {
    staticStyle: {
      "font-size": "1rem",
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.errorMsg))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footerfrm"
  }, [_c('center', [_c('button', {
    staticClass: "btn btn-success",
    staticStyle: {
      "background-color": "#20a8d8"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.errorModalShow = false
      }
    }
  }, [_vm._v("Ok")])])], 1)])])]), _vm._v(" "), _c('b-modal', {
    ref: "awbStatusModalRef",
    attrs: {
      "id": "#confirmationmodal3",
      "title": "Confirmation"
    },
    model: {
      value: (_vm.awbStatusModalShow),
      callback: function($$v) {
        _vm.awbStatusModalShow = $$v
      },
      expression: "awbStatusModalShow"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content",
    staticStyle: {
      "width": "150%"
    }
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h5', {
    staticClass: "modal-title",
    staticStyle: {
      "font-size": "1rem"
    }
  }, [_vm._v("AWBNo's Validation Error(s)")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeStatusRoleModal
    }
  }, [_c('span', {
    staticStyle: {
      "color": "white"
    },
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader",
    staticStyle: {
      "width": "50%"
    }
  }, [_c('b', [_vm._v("Reason")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    staticStyle: {
      "width": "49%"
    }
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables"
  }, [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader",
    staticStyle: {
      "width": "29%"
    }
  }, [_c('b', [_vm._v("AWB Number")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    staticStyle: {
      "width": "25%"
    }
  }, [_c('b', [_vm._v(" Status / Payment Mode ")])])])])])])]), _vm._v(" "), _c('tbody', [(_vm.awbnoStatusTabel.length <= 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "4",
      "align": "center"
    }
  }, [_vm._v("No record found")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.awbnoStatusTabel), function(val, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center",
      staticStyle: {
        "width": "50%"
      }
    }, [_vm._v(_vm._s(_vm.getReasonName(index)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      staticStyle: {
        "width": "49%"
      }
    }, [_c('table', {
      staticClass: "table-bordered table-hover tbl datatables"
    }, _vm._l((val), function(row, ind) {
      return _c('tr', [_c('td', {
        staticClass: "text-center",
        staticStyle: {
          "width": "25%"
        }
      }, [_vm._v(_vm._s(row.ShippingID))]), _vm._v(" "), _c('td', {
        staticClass: "text-center",
        staticStyle: {
          "width": "25%"
        }
      }, [_vm._v(_vm._s(row.Status ? row.Status : row.PaymentMode))])])
    }))])])
  })], 2)])]), _vm._v(" "), (_vm.awbnoStatusTabel['nddissAWBNo']) ? _c('p', {
    staticClass: "ml-5"
  }, [_c('b', [_vm._v("Note - Only Delivered AWB No accepted for Non-Delivery Dispute ")])]) : _vm._e(), _vm._v(" "), (_vm.awbnoStatusTabel['walissAWBNo'] || _vm.awbnoStatusTabel['paypissAWBNo'] || _vm.awbnoStatusTabel['razissAWBNo'] || _vm.awbnoStatusTabel['pineAWBNo']) ? _c('p', {
    staticClass: "ml-5"
  }, [_c('b', [_vm._v("Note - Only Cash Payment mode accepted for Wallet / Payphi / Razor / Pinelab issues")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modal-footerfrm"
  }, [_c('center', [_c('button', {
    staticClass: "btn btn-danger",
    staticStyle: {
      "background-color": "#f86c6b"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.awbStatusModalShow = false
      }
    }
  }, [_vm._v("Cancel")])])], 1)])])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-headerfrm",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('h4', {
    staticClass: "header"
  }, [_c('i', {
    staticClass: "fa fa-bars barcolor",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Result \n            (  \n              "), (_vm.resultCount > 0) ? _c('span', {
    staticStyle: {
      "font-size": "13px"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.resultdate) + " : ")])]) : _vm._e(), _vm._v(" \n              "), _c('font', {
    staticStyle: {
      "font-size": "13px"
    }
  }, [_c('span', {
    staticClass: "dot1"
  }), _vm._v(" System Closure\n                "), _c('span', {
    staticClass: "dot2"
  }), _vm._v(" Tax Payment/Imprest\n                "), _c('span', {
    staticClass: "dot3"
  }), _vm._v(" Amount Mismatched\n                "), _c('span', {
    staticClass: "dot4"
  }), _vm._v(" RSC Vendor\n              ")]), _vm._v("\n              )\n          ")], 1), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('table', {
    staticClass: "table-bordered table-hover tbl datatables scrolltb",
    staticStyle: {
      "width": "100%"
    }
  }, [_vm._m(35), _vm._v(" "), _c('tbody', [(_vm.resultCount == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "18",
      "align": "center"
    }
  }, [_vm._v("No record found")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.listSVCledgerData), function(data, index) {
    return _c('tr', {
      class: ("" + ((data.createdby == 'schedular@xpressbees.com') || (data.deposittype == '' && ![366,367,168,169].includes(data.financereasonid)) ? 'scheduler' : '' || data.reasonid == 65 ? 'other' : '' || ([84,124,187,218,125,374,175].includes(data.financereasonid)) ? 'mismatched' : ([366,367,168,169].includes(data.financereasonid)) ? 'fnfrsc' : ''))
    }, [_c('td', {
      staticClass: "text-center",
      attrs: {
        "scope": "row"
      }
    }, [_c('strong', [_vm._v(_vm._s(_vm.pageno + index + 1))])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.deliverydate))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.bankdepositdate))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.deposittype))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.openingbalance))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.codamount))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.bankname))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.bankdeposit))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.actualrecamt))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [(data.exceptionamt != 0) ? _c('span', {
      staticStyle: {
        "cursor": "pointer",
        "color": "rgb(25,25,112)",
        "text-decoration": "underline"
      },
      on: {
        "click": function($event) {
          _vm.showRecExcAWBNo('exception', data.exceptionamt, data.awbno)
        }
      }
    }, [_vm._v(_vm._s(data.exceptionamt))]) : _vm._e(), _vm._v(" "), (data.exceptionamt == 0) ? _c('span', [_vm._v(_vm._s(data.exceptionamt))]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [(data.cardawbno.length > 0) ? _c('span', {
      staticStyle: {
        "cursor": "pointer",
        "color": "rgb(25,25,112)",
        "text-decoration": "underline"
      },
      on: {
        "click": function($event) {
          _vm.showReasonAWBNo(data.cardawbno)
        }
      }
    }, [_vm._v(_vm._s(data.cardissueamt))]) : _vm._e(), _vm._v(" "), (data.cardawbno.length <= 0) ? _c('span', [_vm._v(_vm._s(data.cardissueamt))]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.closingbalance))]), _vm._v(" "), (data.statusid == 1) ? _c('td', {
      staticClass: "text-center"
    }, [_vm._v("Open")]) : _vm._e(), _vm._v(" "), (data.statusid == 6) ? _c('td', {
      staticClass: "text-center"
    }, [_vm._v("Close")]) : _vm._e(), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [(data.comment) ? _c('span', {
      staticStyle: {
        "cursor": "pointer",
        "color": "rgb(25,25,112)",
        "text-decoration": "underline"
      },
      on: {
        "click": function($event) {
          _vm.showComment(data.comment, 'c')
        }
      }
    }, [_vm._v(_vm._s(data.financereason))]) : _vm._e(), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: ((['', null].includes(data.comment))),
        expression: "(['',null].includes(data.comment))"
      }]
    }, [_vm._v(_vm._s(data.financereason))])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [(data.files.length > 0 && data.createdby != 'schedular@xpressbees.com' && data.othercharges == '0.00') ? _c('span', {
      staticStyle: {
        "color": "blue",
        "cursor": "pointer",
        "text-decoration": "underline"
      },
      attrs: {
        "id": ("" + ("vrl"+data.svcledgerid))
      },
      on: {
        "click": function($event) {
          _vm.showHideImages(data.svcledgerid, 'vrl')
        }
      }
    }, [_vm._v("Deposit")]) : _vm._e(), _vm._v(" "), _c('span', {
      staticStyle: {
        "display": "none"
      },
      attrs: {
        "id": ("" + ("vri"+data.svcledgerid))
      }
    }, _vm._l((data.files), function(file) {
      return _c('a', {
        attrs: {
          "title": ("" + (file.name)),
          "href": ("" + (file.url))
        }
      }, [_c('i', {
        staticClass: "fa fa-download",
        staticStyle: {
          "font-size": "20px",
          "color": "#4b8cbb",
          "margin": "10px 10px 1px 1px"
        },
        attrs: {
          "aria-hidden": "true"
        }
      })])
    })), _vm._v(" "), _c('br'), ((data.reasonfiles.length > 0 && data.createdby != 'schedular@xpressbees.com')) ? _c('span', {
      staticStyle: {
        "color": "blue",
        "cursor": "pointer",
        "text-decoration": "underline"
      },
      attrs: {
        "id": ("" + ("vrrl"+data.svcledgerid))
      },
      on: {
        "click": function($event) {
          _vm.showHideImages(data.svcledgerid, 'vrrl')
        }
      }
    }, [_vm._v("Other")]) : _vm._e(), _vm._v(" "), _c('span', {
      staticStyle: {
        "display": "none"
      },
      attrs: {
        "id": ("" + ("vrri"+data.svcledgerid))
      }
    }, _vm._l((data.reasonfiles), function(file) {
      return _c('a', {
        attrs: {
          "title": ("" + (file.name)),
          "href": ("" + (file.url))
        }
      }, [_c('i', {
        staticClass: "fa fa-download",
        staticStyle: {
          "font-size": "20px",
          "color": "#4b8cbb",
          "margin": "10px 10px 1px 1px"
        },
        attrs: {
          "aria-hidden": "true"
        }
      })])
    }))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.createdby))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [(data.transactionid && data.transactionid != 0) ? _c('span', {
      staticStyle: {
        "cursor": "pointer",
        "color": "rgb(25,25,112)",
        "text-decoration": "underline"
      },
      on: {
        "click": function($event) {
          _vm.showComment(data.transactionid, 't')
        }
      }
    }, [_vm._v("view")]) : _vm._e(), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: ((['', null, 0].includes(data.transactionid))),
        expression: "(['',null,0].includes(data.transactionid))"
      }]
    })])])
  })], 2)]), _c('br'), _vm._v(" "), (_vm.resultCount > 0) ? _c('paginate', {
    attrs: {
      "page-count": _vm.pagecount,
      "page-range": 2,
      "margin-pages": 2,
      "click-handler": _vm.getPaginationData,
      "prev-text": '«',
      "next-text": '»',
      "container-class": 'pagination'
    }
  }) : _vm._e()], 1)])])])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-append"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_c('i', {
    staticClass: "fa fa-angle-down"
  })])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-append"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_c('i', {
    staticClass: "fa fa-calendar"
  })])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-append"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_c('i', {
    staticClass: "fa fa-calendar"
  })])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-append"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_c('i', {
    staticClass: "fa fa-rupee"
  })])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-append"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_c('i', {
    staticClass: "fa fa-angle-down"
  })])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-append"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_c('i', {
    staticClass: "fa fa-bank"
  })])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-append"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_c('i', {
    staticClass: "fa fa-exchange"
  })])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend",
    staticStyle: {
      "width": "140px"
    }
  }, [_c('span', {
    staticClass: "input-group-text",
    staticStyle: {
      "width": "140px"
    }
  }, [_vm._v("Exception AWB No.")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-append"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_c('i', {
    staticClass: "fa fa-align-justify"
  })])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend",
    staticStyle: {
      "width": "140px"
    }
  }, [_c('span', {
    staticClass: "input-group-text",
    staticStyle: {
      "width": "140px"
    }
  }, [_vm._v("Exception Amount")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-append"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_c('i', {
    staticClass: "fa fa-rupee"
  })])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-append"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_c('i', {
    staticClass: "fa fa-file"
  })])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Notes")]), _vm._v(" "), _c('th', [_vm._v("Count")]), _vm._v(" "), _c('th', [_vm._v("Amount")])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "notes"
  }, [_c('strong', [_vm._v("Total")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('i', {
    staticClass: "fa fa-align-justify"
  }), _vm._v(" COD Amount")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "position": "sticky",
      "top": "0",
      "background": "white",
      "z-index": "100",
      "padding": "8px"
    }
  }, [_vm._v("SR Name")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "position": "sticky",
      "top": "0",
      "background": "white",
      "z-index": "100",
      "padding": "8px"
    }
  }, [_vm._v("Amount")])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticStyle: {
      "position": "sticky",
      "bottom": "0",
      "background": "white",
      "z-index": "100",
      "padding": "8px 51px"
    }
  }, [_c('b', [_vm._v("Total")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('select', [_c('option', [_vm._v("-- Select Reason --")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-append"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_c('i', {
    staticClass: "fa fa-angle-down"
  })])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-append"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_c('i', {
    staticClass: "fa fa-rupee"
  })])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-append"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_c('i', {
    staticClass: "fa fa-file"
  })])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-append"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_c('i', {
    staticClass: "fa fa-truck"
  })])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-append"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_c('i', {
    staticClass: "fa fa-truck"
  })])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-append"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_c('i', {
    staticClass: "fa fa-truck"
  })])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-append"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_c('i', {
    staticClass: "fa fa-truck"
  })])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-append"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_c('i', {
    staticClass: "fa fa-truck"
  })])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-append"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_c('i', {
    staticClass: "fa fa-truck"
  })])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-append"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_c('i', {
    staticClass: "fa fa-truck"
  })])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-append"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_c('i', {
    staticClass: "fa fa-truck"
  })])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-append"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_c('i', {
    staticClass: "fa fa-rupee"
  })])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-append"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_c('i', {
    staticClass: "fa fa-rupee"
  })])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-append"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_c('i', {
    staticClass: "fa fa-rupee"
  })])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-append"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_c('i', {
    staticClass: "fa fa-rupee"
  })])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-append"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_c('i', {
    staticClass: "fa fa-rupee"
  })])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-append"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_c('i', {
    staticClass: "fa fa-file"
  })])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("#")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Delivery Date")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Deposit Date")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Deposit Type")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Opening Amount "), _c('br'), _vm._v("( "), _c('i', {
    staticClass: "fa fa-rupee"
  }), _vm._v(" )")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("COD Receivable "), _c('br'), _vm._v("( "), _c('i', {
    staticClass: "fa fa-rupee"
  }), _vm._v(" )")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Bank Name")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Bank Deposited Amount "), _c('br'), _vm._v("( "), _c('i', {
    staticClass: "fa fa-rupee"
  }), _vm._v(" )")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Finance Confirmed Amount "), _c('br'), _vm._v("( "), _c('i', {
    staticClass: "fa fa-rupee"
  }), _vm._v(" )")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Exception AWB Amount "), _c('br'), _vm._v("( "), _c('i', {
    staticClass: "fa fa-rupee"
  }), _vm._v(" )")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Dispute Amount "), _c('br'), _vm._v("( "), _c('i', {
    staticClass: "fa fa-rupee"
  }), _vm._v(" )")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Outstanding Amount "), _c('br'), _vm._v("( "), _c('i', {
    staticClass: "fa fa-rupee"
  }), _vm._v(" )")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Status")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Finance Reason")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("View Receipt")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Created By")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Transaction Id")])])])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-37364d64","hasScoped":true}!./src/views/components/svcclosurep2p/svcclosurep2p.component.html
// module id = 630
// module chunks = 1